import { render } from "./PendingTransfertPage.vue?vue&type=template&id=26658e0b&ts=true"
import script from "./PendingTransfertPage.vue?vue&type=script&lang=ts"
export * from "./PendingTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__